export default __webpack_public_path__ + "static/media/christine dewi.6c3b5a2f.png";